export default __webpack_public_path__ + "static/media/whitelabel-white.bf8496f5.svg";